import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import bgImage from '../img/2.jpg';

export default function WelcomePage() {
  const navigate = useNavigate();
  const { user } = useSelector(s => s.auth);

  useEffect(() => {
    if (!user) { navigate('/login', { replace: true }); return; }
    const timer = setTimeout(() => navigate('/dashboard', { replace: true }), 5000);
    return () => clearTimeout(timer);
  }, [navigate, user]);

  if (!user) return null;

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      paddingTop: 80,
      backgroundImage: `url(${bgImage})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      fontFamily: 'Georgia, "Times New Roman", serif',
      position: 'relative',
    }}>

      {/* Bienvenue + Nom — angle haut droite */}
      <div style={{
        position: 'absolute', top: 40, right: 50,
        textAlign: 'right', zIndex: 1,
        background: 'rgba(255,255,255,0.82)',
        borderRadius: 16, padding: '20px 32px',
        boxShadow: '0 6px 24px rgba(0,0,0,0.18)',
        backdropFilter: 'blur(4px)',
      }}>
        <div style={{
          color: '#1F4E79',
          fontSize: 46,
          fontWeight: 700,
          fontFamily: '"Palatino Linotype", Palatino, Georgia, serif',
          fontStyle: 'italic',
          letterSpacing: '1px',
          lineHeight: 1.1,
        }}>
          Bienvenue !
        </div>
        <div style={{
          color: '#C00000',
          fontSize: 28,
          fontWeight: 700,
          fontFamily: '"Palatino Linotype", Palatino, Georgia, serif',
          fontStyle: 'italic',
          marginTop: 8,
        }}>
          {user.prenom_util} {user.nom_util}
        </div>
      </div>
    </div>
  );
}
